import { taskSocketManager } from "../../../services/appRegistry";
import { socketRequest } from "../../../services/socketRequest";
import {
  CollectionDto,
  TaskInCollectionDto,
  RemoveTaskFromCollectionAnserDto,
  UpdateCollectionDto,
  UpdatedNoteInCollectionDto,
} from "./collection.types";

const request = <T>(
  event: string,
  payload?: unknown,
  options?: Parameters<typeof socketRequest<T>>[3],
) => socketRequest<T>(taskSocketManager, event, payload, options);

const createQuickCollection = (): Promise<CollectionDto> =>
  request("createQuickCollection");

const addTaskToCollection = (
  taskId: string,
  collectionId: string,
): Promise<TaskInCollectionDto> =>
  request("addTaskToCollection", { taskId, collectionId });

const removeTaskFromCollection = (
  taskId: string,
  collectionId: string,
): Promise<RemoveTaskFromCollectionAnserDto> =>
  request("removeTaskFromCollection", { taskId, collectionId });

const getCollections = (
  groupId?: string,
  organizationId?: string,
): Promise<CollectionDto[]> =>
  request("getCollections", { groupId, organizationId });

const getCollection = (collectionId?: string): Promise<CollectionDto> =>
  request("getCollection", { collectionId });

const deleteCollection = (collectionId: string): Promise<string> =>
  request("deleteCollection", { collectionId: collectionId });

const updateCollection = (
  updateCollectionData: UpdateCollectionDto,
): Promise<CollectionDto> =>
  request("updateCollection", {
    updateCollectionData: updateCollectionData,
    collectionId: updateCollectionData.id, // For guards
  });

const updateNotePositionsInCollection = (
  updatedNotes: UpdatedNoteInCollectionDto[],
  collectionId: string,
): Promise<UpdatedNoteInCollectionDto[]> =>
  request(
    "updateNotePositionsInCollection",
    { updatedNotes, collectionId },
    { transform: (response) => response.data },
  );

// Rows

const collectionService = {
  createQuickCollection,
  getCollections,
  getCollection,
  updateCollection,
  addTaskToCollection,
  deleteCollection,
  removeTaskFromCollection,
  updateNotePositionsInCollection,
};
export default collectionService;
